import React, { memo, useEffect } from 'react';
import { Slide, toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import ModalRegistrar from '../../modals/ModalRegistrar';
import server from '../../../static/images/server.svg';

const Wrapper = ({ children }) => {
  useEffect(() => {
    toast.configure({
      role: 'alert',
      hideProgressBar: true,
      transition: Slide,
      closeButton: false,
      position: 'bottom-right',
      pauseOnFocusLoss: false,
    });
  }, []);

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>Reactive Resume</title>
        <meta
          name="description"
          content="A free and open source resume builder that’s built to make the mundane tasks of creating, updating and sharing your resume as easy as 1, 2, 3."
        />
        <link rel="canonical" href="https://rxresu.me" />
        <meta property="og:url" content="https://rxresu.me" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="A free and open source resume builder that’s built to make the mundane tasks of creating, updating and sharing your resume as easy as 1, 2, 3."
        />
        <meta property="og:image" content="http://rxresu.me/images/share.png" />
        <link
          href="https://fonts.googleapis.com/css?family=Work Sans"
          rel="stylesheet"
        />
        <script
          type="text/javascript"
          src="https://app.midtrans.com/snap/snap.js"
          data-client-key="Mid-client-RtTEQ-NN-A8JV-ws"
        />
      </Helmet>

      {/* {children} */}
      <div className="flex justify-center mt-72">
        <img src={server} style={{ width: '20rem' }} />
        <br />
      </div>
      <div className="text-center text-4xl font-extrabold m-8">
        Website under maintenance
      </div>
      <div className="text-center text-2xl m-11">
        This website is currently undergoing scheduled maintenance. We should be
        back shortly.
      </div>

      <ModalRegistrar />
    </>
  );
};

export default memo(Wrapper);
